import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { IInvoice, IOrder } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/invoices';
const $urlActionsGetOrders = '/admin/invoices/actions/getOrders';
const $urlActionsCancellation = '/admin/invoices/actions/cancellation';
const $urlActionsDelivery = '/admin/invoices/actions/delivery';

interface IGetRequest {
  status: string;
}

interface IGetOrdersRequest {
  userName: string;
  invoiceId: string;
}

interface IGetOrdersResult {
  orders: IOrder[];
}

interface ICancellationRequest {
  invoiceId: number;
  status: string;
}

interface IGetResult {
  items: IInvoice[];
  defaultCount: number;
  deliveredCount: number;
  cancellationCount: number;
}

interface IDeliveryRequest {
  invoiceId: number;
  memo: string;
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  getOrders(req: IGetOrdersRequest, success: (res: IGetOrdersResult) => void) {
    utils.loading(true);
    request
      .get($urlActionsGetOrders, {
        params: req,
      })
      .then((response: AxiosResponse<IGetOrdersResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  cancellation(req: ICancellationRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlActionsCancellation, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delivery(req: IDeliveryRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlActionsDelivery, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
